import { render, staticRenderFns } from "./CreatePaymentKasbonDriver.vue?vue&type=template&id=2fff7262"
import script from "./CreatePaymentKasbonDriver.vue?vue&type=script&lang=js"
export * from "./CreatePaymentKasbonDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports